import NotificationDocumentTypeId from "../enums/NotificationDocumentTypeIds";

export default interface NotificationTemplateFormatOption {
    id: number;
    label: string;
}

export const notificationTemplateFormats: NotificationTemplateFormatOption[] = [
    { id: NotificationDocumentTypeId.Pdf, label: "Attached" },
    { id: NotificationDocumentTypeId.Png, label: "Embedded" },
    { id: NotificationDocumentTypeId.Html, label: "Html" }
]